import { FC } from 'react';
import { useIntl } from 'react-intl';
import { CalculatorCurrencyField } from '@components/common/CalculatorCurrencyField/CalculatorCurrencyField';
import { CalculatorFormControl } from '@components/common/CalculatorFormControl/CalculatorFormControl';
import { SalariedDirectorFieldsQuestions } from './questions';
import { SalariedDirectorFieldsProps } from './types';

export const SalariedDirectorFields: FC<SalariedDirectorFieldsProps> = ({
  applicantNumber,
  incomeType,
  isTimeTradingMoreThanTwoYears,
}) => {
  const intl = useIntl();

  const {
    timeTrading,
    basicAnnualSalaryPreviousYear,
    basicAnnualSalaryRecentYear,
    dividendsPreviousYear,
    dividendsRecentYear,
    error,
  } = SalariedDirectorFieldsQuestions;

  return (
    <>
      <CalculatorFormControl
        className={'xs:mb-5 md:mb-10'}
        name={`applicants[${applicantNumber}].${incomeType}.timeTrading`}
        titleKey={timeTrading.titleKey}
        textKey={timeTrading.textKey}
        radioOptions={timeTrading.options}
        rules={{ required: intl.formatMessage({ id: error.required }) }}
        isWide
      />
      <CalculatorCurrencyField
        name={`applicants[${applicantNumber}].${incomeType}.basicAnnualSalaryRecentYear`}
        titleKey={basicAnnualSalaryRecentYear.titleKey}
        textKey={basicAnnualSalaryRecentYear.textKey}
        rules={{ required: intl.formatMessage({ id: error.required }) }}
        className={'xs:mb-5 md:mb-10'}
      />
      <CalculatorCurrencyField
        name={`applicants[${applicantNumber}].${incomeType}.dividendsRecentYear`}
        titleKey={dividendsRecentYear.titleKey}
        rules={{ required: intl.formatMessage({ id: error.required }) }}
        className={'xs:mb-5 md:mb-10'}
      />
      {isTimeTradingMoreThanTwoYears && (
        <>
          <CalculatorCurrencyField
            name={`applicants[${applicantNumber}].${incomeType}.basicAnnualSalaryPreviousYear`}
            titleKey={basicAnnualSalaryPreviousYear.titleKey}
            textKey={basicAnnualSalaryPreviousYear.textKey}
            rules={{ required: intl.formatMessage({ id: error.required }) }}
            className={'xs:mb-5 md:mb-10'}
          />
          <CalculatorCurrencyField
            name={`applicants[${applicantNumber}].${incomeType}.dividendsPreviousYear`}
            titleKey={dividendsPreviousYear.titleKey}
            rules={{ required: intl.formatMessage({ id: error.required }) }}
            className={'xs:mb-6 md:mb-12'}
          />
        </>
      )}
    </>
  );
};
